module.exports = __webpack_public_path__ + "static/media/logo-inline.e8579334.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo-inline.svg
// module id = 356
// module chunks = 0